// src/features/rrhh/mensajeria/components/MensajesSearchPanel.jsx
import {
  Box,
  Button,
  Chip,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMemo, useState } from "react";

export default function MensajesSearchPanel({
  temas = [],
  tema,
  setTema,
  search,
  setSearch,
  tipo,
  setTipo,
  children,
}) {
  const temaOptions = useMemo(
    () => ["General", ...temas.filter((t) => t !== "General")],
    [temas],
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const labelTema = tema && tema !== "General" ? tema : "Seleccionar tema";

  return (
    <Stack spacing={1}>
      {/* Row: input + tema dropdown */}
      <Stack
        direction="row"
        spacing={1}
        sx={{ flexWrap: "wrap", alignItems: "center" }}
      >
        <TextField
          value={search}
          onChange={(e) => setSearch?.(e.target.value)}
          placeholder="Texto de input (guía)"
          size="small"
          sx={{
            flex: 1,
            width: "100%",
            "& .MuiOutlinedInput-root": {
              height: 32,
              borderRadius: 999,
              bgcolor: (t) => t.palette?.neutral?.[50],
              boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.45)",
              "& fieldset": { border: "none" },
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon
                  sx={{
                    color: (t) => t.palette?.primary?.[900],
                    opacity: 0.9,
                  }}
                />
              </InputAdornment>
            ),
          }}
        />

        <Box>
          <Button
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{
              px: 1,
              py: 0.75,
              borderRadius: 999,
              bgcolor: (t) => t.palette?.secondary?.[500],
              color: "common.white",
              boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.45)",
              "&:hover": { bgcolor: (t) => t.palette?.secondary?.[600] },
            }}
            endIcon={<ExpandMoreIcon sx={{ color: "common.white" }} />}
          >
            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
              {labelTema}
            </Typography>
          </Button>

          <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
            {temaOptions.map((t) => (
              <MenuItem
                key={t}
                onClick={() => {
                  setTema?.(t);
                  setAnchorEl(null);
                }}
              >
                {t}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Stack>

      {/* Row: chips */}
      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: "center", flexWrap: "wrap" }}
      >
        <FilterAltIcon sx={{ color: (t) => t.palette?.primary?.[900] }} />
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "primary.900" }}>
          Filtrar mensajes:
        </Typography>

        {["Todos", "Enviados", "Recibidos"].map((k) => {
          const active = tipo === k;
          return (
            <Chip
              key={k}
              label={k}
              onClick={() => setTipo?.(k)}
              sx={{
                borderRadius: 999,
                fontWeight: 700,
                bgcolor: active
                  ? (t) => t.palette?.secondary?.[800]
                  : (t) => t.palette?.secondary?.[500],
                color: "common.white",
              }}
            />
          );
        })}
      </Stack>

      {/* Content */}
      <Box
        sx={{
          p: 1,
          borderRadius: "20px",
          bgcolor: (t) => t.palette?.neutral?.[50],
          boxShadow: "inset 0px 0px 4px rgba(165, 165, 178, 0.9)",
          height: "36.5vh",        
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children ? (
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "hidden" }}>
            {children}
          </Box>
        ) : (
          <Stack
            spacing={3}
            sx={{
              flex: 1,
              minHeight: 0,
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              px: 6,
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 999,
                bgcolor: (t) => t.palette?.primary?.[500],
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <SearchIcon sx={{ color: "common.white", fontSize: 48 }} />
            </Box>
            
            <Typography sx={{ fontSize: 18, fontWeight: 700, color: "primary.900" }}>
              Inicia tu búsqueda
            </Typography>
            <Typography sx={{ fontSize: 16, color: "primary.900", opacity: 0.9 }}>
              Busca los mensajes por tema o por nombre en la barra de búsqueda
            </Typography>
          </Stack>
        )}
      </Box>
    </Stack>
  );
}
